import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Container, Wrapper } from './style';
import { VscEye, VscEyeClosed } from 'react-icons/vsc';
import refreshIcon from '../../assets/refresh.svg';
import transferIcon from '../../assets/transfernew.svg';
import TopupIcon from '../../assets/plusnew.svg';
import MessageIcon from '../../assets/messagenew.svg';
import PhonebookIcon from '../../assets/Phonebook2.svg';
import Transaction from '../../assets/transactionnew.svg';
import mathFrame from '../../assets/math.svg';
import contact from '../../assets/contactnew.svg';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import RecentTable from './RecentTable';
import { useDispatch, useSelector } from 'react-redux';
import {
   getAuthSelector,
   message,
   messageSelector,
   transaction,
} from '../../components/utils/selectors/selectors';
import { Link, useNavigate } from 'react-router-dom';
import { getUserMessages } from '../../components/app/features/message/messageSlice';
import { getActivities } from '../../components/app/features/transactions/TransactionSlice';
import Slider from './Slider';
import { getUserProfile } from '../../components/app/features/auth/AuthSlice';
import { userLSAuth } from '../../components/app/features/env';
import TransferDialog from '../../components/modal/TransferDialog';

import './style.css';
import { FaAngleRight } from 'react-icons/fa';
import { getBaseUrls } from '../../components/app/features/env';
import ParroticaOnboardingDialog from '../../components/signup_dialog/ParroticaOnboardingDialog';


const FirstPage = () => {
   const [isShowPwd, setIsShowPwd] = React.useState(true);
   const [reset, setReset] = React.useState(false);
   const [numOfMsg, setNumOfMsg] = React.useState(0);
   const [month, setMonth] = React.useState('');
   const [balance, setBalance] = React.useState(0);
   const [dialogshow, setdialogshow] = useState(false);
   const [isOnboardingOpen, setIsOnboardingOpen] = useState(false);
   const showAppIntro = useSelector((state) => state.auth.showAppIntro);
  




   const authselector = useSelector(getAuthSelector);
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const msgSelector = useSelector(messageSelector);
   const transSelector = useSelector(transaction);
   const selector = useSelector(messageSelector);
   const [dialogOpen, setDialogOpen] = useState(false);

   const togglePassword = () => setIsShowPwd(!isShowPwd);
   const handleOpen = () => setDialogOpen(true);
   const handleClose = () => setDialogOpen(false);


   const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
   ];




   React.useEffect(() => {
      dispatch(getUserProfile());

      setTimeout(() => {
         if (authselector.updated === true) {

            setReset(false);
         }
      }, 1500);
   }, [reset === true]);

   React.useEffect(() => {
      dispatch(getUserMessages());
      dispatch(getActivities({ page: 1 }));
   }, [dispatch]);

   React.useEffect(() => {
      if (authselector.updatedProfile !== null) {
         setBalance(
            authselector.updatedProfile.balance !== null
               ? authselector.updatedProfile.balance
               : 0

         );

      }
   }, [authselector.updated === true]);

   React.useEffect(() => {
      const fetchData = async () => {
         try {
            const token = localStorage.getItem('accessToken');
            const url = `${getBaseUrls().data}/v1/message/${userLSAuth().id
               }?page=1&take=10+&state=history`;
            const response = await fetch(url, {
               method: 'GET',
               headers: {
                  Authorization: `Bearer ${token}`,
                  'Content-Type': 'application/json',
               },
            });

            if (response.ok) {
               const result = await response.json();
               const messages = result.data;
               let currentDate = new Date();
               let currentMonth = currentDate.getMonth();
               let currentYear = currentDate.getFullYear();
               setMonth(`${monthNames[currentMonth]} ${currentYear}`);
               if (messages.length > 0) {
                  let count = 0;
                  const month = new Date().getMonth();
                  const year = new Date().getFullYear();
                  const isoMonthString = new Date(year, month, 1).toISOString();
                  messages.filter((item) => {
                     const itemDate = new Date(item.createdAt);
                     const currentMonthCompare = new Date(isoMonthString);
                     const isSameMonth =
                        currentMonthCompare.getFullYear() ===
                        itemDate.getFullYear() &&
                        currentMonthCompare.getMonth() === itemDate.getMonth();

                     if (isSameMonth) {
                        count += 1;
                     }
                  });
                  setNumOfMsg(count);
               }
            }
         } catch (error) {
            console.error('Error:', error);
         }
      };

      fetchData();
   }, []);
   return (
      <Wrapper style={{ background: '#f8f8f8' }}>
      
        <ParroticaOnboardingDialog
        isOpen={showAppIntro}
        onClose={() => setIsOnboardingOpen(false)}
      />
   
         <Container>
            <Box
               sx={{
                  display: 'flex',
                  columnGap: '1%',
                  flexWrap: 'wrap',
                  rowGap: '1vh',
               }}
            >
               <Box
                  className="font-cormorant"
                  sx={{
                     position: 'relative',
                     width: '49.5%',
                     borderRadius: '16px',
                     boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.1)',
                     background: '#eaf2ff',

                     display: 'flex',
                     flexDirection: 'column',
                     justifyContent: 'space-between',
                     '@media(max-width: 805px)': {
                        border: '16px',
                        width: '100%',
                     },
                  }}
               >
                  <Box>
                     <Typography
                        className='font-cormorant'
                        sx={{
                           color: '#2E2C21',
                           fontSize: '2rem',
                           fontWeight: '600',
                           textAlign: 'center',

                        }}
                     >
                        Account Balance
                     </Typography>
                     <div
                        style={{
                           color: '#2E2C21',
                           fontSize: '4.7rem',

                           fontWeight: '400',
                           textAlign: 'center',
                           padding: '0px',
                           margin: '0px'
                        }}
                     >
                        {isShowPwd ? userLSAuth()?.balance ?? '0' : '*****'}
                     </div>
                     <Typography
                        sx={{
                           color: '#2E2C21',
                           fontSize: 'clamp(1.2rem, 2.5vw, 1.4rem)',
                           fontSize: '1.2rem',
                           fontWeight: '400',
                           textAlign: 'center',


                        }}
                     >
                        SMS Units
                     </Typography>
                  </Box>
                  <Box style={{ display: 'flex', justifyContent: "center", columnGap: '16px', padding: '1rem' }} >

                     <Button
                        onClick={handleOpen}
                        sx={{
                           color: '#fff',
                           display: 'flex',
                           alignItems: 'center',
                           background: '#0040BF',
                           width: 'max-content',
                           padding: '0.375rem 1.3rem',
                           borderRadius: '8px',
                           fontWeight: '500',

                           fontSize: '1rem',


                           cursor: 'pointer',
                           ':hover': {
                              background: '#0045BF',
                           },
                        }}
                     >
                        Transfer units
                        <img
                           src={transferIcon}

                           style={{
                              marginLeft: '5px',
                              width: '20px',
                           }}
                           alt="refresh"
                        />
                     </Button>
                     <Button
                        sx={{
                           color: '#0040BF',
                           display: 'flex',
                           alignItems: 'center',
                           background: '#fff',
                           width: 'max-content',
                           padding: '0.375rem 2.19rem',
                           borderRadius: '8px',
                           fontSize: '1rem',
                           fontWeight: '500',


                           cursor: 'pointer',
                           ':hover': {
                              background: '#fff',
                           },
                        }}
                        onClick={() => setReset(true)}
                     >
                        Refresh{' '}
                        <img
                           src={refreshIcon}
                           className={reset === true ? 'rotating-element' : ''}
                           style={{
                              marginLeft: '5px',
                              width: '20px',
                           }}
                           alt="refresh"
                        />
                     </Button>
                     <TransferDialog open={dialogOpen} onClose={handleClose} setReset={setReset} />
                     {/* {isShowPwd ? (
                     <VscEye
                        size={25}
                        style={{
                           position: 'absolute',
                           bottom: '15px',
                           right: '20px',
                           color: '#fff',
                           cursor: 'pointer',
                        }}
                        onClick={togglePassword}
                     />
                  ) : (
                     <VscEyeClosed
                        size={25}
                        style={{
                           position: 'absolute',
                           bottom: '15px',
                           right: '20px',
                           color: '#fff',
                           cursor: 'pointer',
                        }}
                        onClick={togglePassword}
                     />
                  )} */}
                  </Box>
               </Box>
               <Box
                  sx={{
                     width: '49.5%',
                     
                   borderRadius: '16px',
                     boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.1)',
                     background: '#eaf2ff',
                    
                     cursor: 'pointer',
                    
                     display: 'flex',
                     flexDirection: 'column',
                     
                    
                     '@media(max-width: 705px)': {
                        width: '100%',
                         borderRadius: '16px',
                     },
                  }}
                  onClick={() => navigate('/send-message/history')}
               >
                  <Typography
                     className='font-cormorant'
                        sx={{
                           color: '#2E2C21',
                           fontSize: '2rem',
                           fontWeight: '600',
                           textAlign: 'center',
                           marginTop:'0.2rem',

                        }}
                  >
                     Message History
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
                     <Box
                        sx={{
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                        }}
                     >
                        <img
                           src={mathFrame}
                           alt="card"
                           style={{ width: '90px', margin: '1rem 0 0.5rem 0' }}
                        />
                        <Typography
                           sx={{
                              textAlign: 'center',
                             
                              fontSize: 'clamp(0.95rem, 1.5vw, 1rem)',
                              fontWeight: '400',
                              color: '#2E2C21',
                           }}
                        >
                           Check Message Status
                        </Typography>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           flexDirection: 'column',
                           alignItems: 'center',
                        }}
                     >
                        <Box
                           sx={{
                              width: '95px',
                              margin: '1rem 0 0.5rem 0',
                              height: '92px',
                              borderRadius: '50%',
                              background: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                           }}
                        >
                           <Typography
                              sx={{
                                 fontWeight: '500',
                                 fontSize: '1.5rem',
                                
                                 color: '#0040BF',
                                 margin: '0',
                                 lineHeight: '1',
                              }}
                           >
                              {msgSelector?.messages ? numOfMsg : 0}
                           </Typography>
                           <Typography
                              sx={{
                                 // marginTop: '0.4rem',
                                 fontWeight: '400',
                                 fontSize: '0.85rem',
                                
                                 color: '#0040BF',
                                 lineHeight: '1.6',
                              }}
                           >
                              Messages
                           </Typography>
                        </Box>

                        <Typography
                           sx={{
                              textAlign: 'center',
                              fontFamily: "'Raleway', 'Montserrat', sans-serif",
                              fontSize: 'clamp(0.95rem, 1.5vw, 1rem)',
                              fontWeight: '400',
                              color: '#2E2C21',
                           }}
                        >
                           {month}
                        </Typography>
                     </Box>
                  </Box>
               </Box>
            </Box>
            
            <div style={{fontWeight:'600', fontSize:'1.6rem',marginTop:'2rem',marginBottom:'0.7rem'}} className='font-cormorant'>
               Quick Actions
            </div>
            <Box
               sx={{
                  justifyContent: 'space-between',
                  display: 'flex',
                  columnGap: '1%',
                  marginTop: '1vh',
                  flexWrap: 'wrap',
                  rowGap: '1vh',
               }}
            >
               <Box
                  sx={{
                     width: '24%',
                    boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.1)',
                     background: '#eaf2ff',
                     display: 'flex',
                     flexDirection: 'column	',
                     alignItems: 'center',
                     justifyContent: 'center',
                     padding: '15px 0',
                     cursor: 'pointer',
                     borderRadius: '16px',
                     minHeight: '130px', 
                     '&:hover': {
                        transform: 'scale(1.02)',
                     },
                     '@media(max-width: 705px)': {
                        width: '49.5%',
                        borderRadius: '16px',
                     },
                  }}
                  onClick={() => navigate('/send-message/message')}
               >
                  <Box
                     borderRadius={50}
                     color="#374DA0"
                     display="flex"
                     textAlign="center"
                     alignItems="center"
                     justifyContent={'center'}
                     width={38}
                     height={38}
                     
                  >
                     <img
                        src={MessageIcon}
                        alt="messageIcon"
                        style={{
                           width: '50px',
                        }}
                     />
                  </Box>

                  <Typography
                  className='font-cormorant'
                    sx={{
                      
                        fontSize: '1.3rem',
                        fontWeight: '600',
                        marginTop: '0.9rem',
                        color:'#2E2C21'
                     
                     }}
                  >
                     Send Message
                  </Typography>
               </Box>
               <Box
                   sx={{
                       width: '24%',
                    boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.1)',
                     background: '#eaf2ff',
                     display: 'flex',
                     flexDirection: 'column	',
                     alignItems: 'center',
                     justifyContent: 'center',
                     padding: '15px 0',
                     cursor: 'pointer',
                     borderRadius: '16px',
                     minHeight: '130px', 
                     '&:hover': {
                        transform: 'scale(1.02)',
                     },
                     '@media(max-width: 705px)': {
                        width: '49.5%',
                        borderRadius: '16px',
                     },
                  }}
                  onClick={() => navigate('/top-up')}
               >
                  <img
                     src={TopupIcon}
                     alt="TopupIcon"
                     style={{
                        width: '50px',
                     }}
                  />
                  <Typography
                   className='font-cormorant'
                   sx={{
                      
                        fontSize: '1.3rem',
                        fontWeight: '600',
                        marginTop: '0.9rem',
                        color:'#2E2C21'
                     
                     }}
                  >
                     Top-Up
                  </Typography>
               </Box>

               <Box
                   sx={{
                       width: '24%',
                    boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.1)',
                     background: '#eaf2ff',
                     display: 'flex',
                     flexDirection: 'column	',
                     alignItems: 'center',
                     justifyContent: 'center',
                     padding: '15px 0',
                     cursor: 'pointer',
                     borderRadius: '16px',
                     minHeight: '130px', 
                     '&:hover': {
                        transform: 'scale(1.02)',
                     },
                     '@media(max-width: 705px)': {
                        width: '49.5%',
                        borderRadius: '16px',
                     },
                  }}
                  onClick={() => navigate('/contacts')}
               >
                  <Box
                     borderRadius={50}
                     color="#374DA0"
                     display="flex"
                     textAlign="center"
                     alignItems="center"
                     justifyContent={'center'}
                     width={38}
                     height={38}
                 
                  >
                     <img
                        src={contact}
                        alt="contactIcon"
                        style={{
                           width: '50px',
                        }}
                     />
                  </Box>

                  <Typography
                  className='font-cormorant'
                     sx={{
                      
                        fontSize: '1.3rem',
                        fontWeight: '600',
                        marginTop: '0.9rem',
                        color:'#2E2C21'
                     
                     }}
                  >
                     Contacts
                  </Typography>
               </Box>
               <Box
                 sx={{
                    width: '24%',
                    boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.1)',
                     background: '#eaf2ff',
                     display: 'flex',
                     flexDirection: 'column	',
                     alignItems: 'center',
                     justifyContent: 'center',
                     padding: '15px 0',
                     cursor: 'pointer',
                     borderRadius: '16px',
                     minHeight: '130px', 
                     '&:hover': {
                        transform: 'scale(1.02)',
                     },
                     '@media(max-width: 705px)': {
                        width: '49.5%',
                        borderRadius: '16px',
                     },
                  }}
                  onClick={() => navigate('/top-up/transactions')}
               >
                  <Box
                     borderRadius={50}
                     color="#374DA0"
                     display="flex"
                     textAlign="center"
                     alignItems="center"
                     justifyContent={'center'}
                     width={38}
                     height={38}
                   
                  >
                      <img
                        src={Transaction}
                        alt="contactIcon"
                        style={{
                           width: '50px',
                        }}
                     />
                  </Box>

                  <Typography
                   className='font-cormorant'
                    sx={{
                      
                        fontSize: '1.3rem',
                        fontWeight: '600',
                        marginTop: '0.9rem',
                        color:'#2E2C21'
                     
                     }}
                  >
                     Transactions
                  </Typography>
               </Box>
            </Box>
            <Box
               sx={{
                  my: '2rem',
                  // border: '1px solid red',
                  width: '100%',
                 
               }}
            >
                <Typography
               className='font-cormorant'
                style={{fontWeight:'600', fontSize:'1.6rem',marginBottom:'0.7rem'}}
               >
                  Featured
               </Typography>
               <Slider handleOpen={handleOpen} />
            </Box>
            <Box
               sx={{
                  margin: '4rem 0 1rem 0',
                  display: 'flex',
                  justifyContent: 'space-between',
               }}
            >
               <Typography
               className='font-cormorant'
                style={{fontWeight:'600', fontSize:'1.6rem',marginBottom:'0.7rem'}}
               >
                  Recent Activities
               </Typography>
               <Typography
                  sx={{
                     fontWeight: '600',
                     fontSize: 'clamp(0.95rem, 1.5vw, 1rem)',
                     color: '#374da0',
                  }}
               >
                  <Link
                     to="/dashboard/activity"
                     className='font-cormorant'
                     style={{
                        color: '#374da0',
                        display: 'flex',
                        alignItems: 'center',
                        columnGap: '5px',
                        fontWeight: '600',
                        fontSize: '1.3rem',
                     }}
                  >
                     See All
                     <FaAngleRight />
                  </Link>
               </Typography>
            </Box>

            <Box>
               {transSelector?.activities.length > 0 ? (
                  <RecentTable />
               ) : (
                  <Typography
                     sx={{
                        fontSize: '1rem',
                        fontFamily: "'Raleway', 'Montserrat', sans-serif",
                     }}
                  >
                     {`	Hey ${userLSAuth()?.fullName
                        }, your latest Activities will appear here!`}
                  </Typography>
               )}
            </Box>
         </Container>
      </Wrapper>
   );
};

export default FirstPage;
